import uuid from 'uuid-random';

import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { ChangePasswordPopup } from './ChangePasswordPopup';

const popupId = uuid();

export const showChangePasswordPopupAction = ({ onSuccess, id, onClose, ...props }) =>
    addPopupAction({
        id: id || popupId,
        component: ChangePasswordPopup,
        layer: LAYER.LOGIN,
        onSuccess,
        onClose,
        ...props
    });
